/* eslint-disable */
export const POSITION_TYPES = {
  outofroom: -1,
  inroom: 0,
  overlapped: 1,
};
